module.exports = __webpack_public_path__ + "img/1262311-97-6.c1e179c5.png";